import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import setAllProjectsArchiveDataAction from '../actions/setAllProjectsArchiveData'
import setModalDataAction from '../actions/setModalData'
import getReferencesArchive from '../api/getReferencesArchive'
import Title from '../components/Title.jsx'
import ReferencesList from '../components/ReferencesList.jsx'

class ProjectsArchive extends Component {
    componentDidMount() {
        getReferencesArchive()
            .then((data) => {
                setTimeout(() => {
                    this.props.setAllProjectsArchiveDataAction(data)
                }, 500)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    setModalData = (data) => {
        this.props.setModalDataAction(data)
    }

    render() {
        return (
            <div className="projects-archive-container section-spacing--last">
                <div className="container">
                    <div className="row">
                        <Title
                            title={this.props.langData.title}
                            className="header1--center header1--yellow"
                        />
                        <ReferencesList
                            itemsData={this.props.projectsArchiveData}
                            setModalData={this.setModalData}
                            path="/reference"
                            isBckDark
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.projectArchive,
    projectsArchiveData: state.allProjectsArchiveData
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setAllProjectsArchiveDataAction,
    setModalDataAction
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsArchive)



// WEBPACK FOOTER //
// ./src/scripts/containers/ProjectsArchive.jsx